import { Button, Grid, TextField, useMediaQuery } from "@mui/material";
import React, { useContext, useState } from "react";
import { CustomSelect } from "./CustomSelect";
import { useForm } from "../../hooks/useForm";
import { mediaQueries } from "../../media-query/mediaQuery";
import { useNavigate } from "react-router-dom";
import { styleItem } from "../main/MainForm";
import { AppContext } from "../../context/context";
import { postInvoice } from "../../api/getInvoices";
import { LoadingButton } from "@mui/lab";

const initialState = {
  rfc: "",
  name: "",
  postalCode: "",
  regime: "",
  use: "",
  payment: "",
  email: "",
};

const fieldValidations = {
  rfc: {
    required: true,
  },
  name: {
    required: true,
  },
  postalCode: {
    required: true,
    maxLength: 5,
    message: "postalCode debe tener una longitud de 5 caracteres",
  },
  regime: {
    required: true,
  },
  use: {
    required: true,
  },
  payment: {
    required: true,
  },
  email: {
    required: true,
  },
};

export const InvoiceForm = () => {
  const navigate = useNavigate();
  const { data, setData } = useContext(AppContext);
  const { data: dataResponse, loading } = data && data;
  const { inputValues, handleInputOnChange, fieldErrors, cleanForm } = useForm(
    initialState,
    fieldValidations
  );
  const { rfc, name, postalCode, regime, use, payment, email } = inputValues;
  const match2 = useMediaQuery(mediaQueries.tableSize);
  const [disabled, setDisabled] = useState(false);
  const [recaptcha, setRecaptcha] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setData({
      ...data,
      loading: true,
    });
    const form = {
      idNote: dataResponse?.note.id,
      fiscalCustomer: {
        rfc: rfc,
        name: name,
        postal_code: postalCode,
        email: email,
        sat_tax_regime_code: regime,
        sat_cfdi_use_code: use,
        paymentCode: payment,
      },
      invoiceKey: data.origin.invoiceKey,
      date: data.origin.date,
      folio: data.origin.folio,
    };
    if (
      rfc.length === 0 ||
      name.length === 0 ||
      postalCode.length === 0 ||
      email.length === 0 ||
      regime.length === 0 ||
      use.length === 0 ||
      payment.length === 0
    ) {
      setData({
        ...data,
        error: true,
        errorMessage: "Favor de llenar todos los campos.",
      });
      return;
    }
    try {
      setTimeout(() => {
        postInvoice(form).then((resp) => {
          if (resp?.message?.error) {
            setData({
              ...data,
              loading: false,
              error: true,
              errorMessage: resp.message.error,
              status: 0,
            });
          } else {
            setData({ ...data, files: resp.data, status: resp.status });
            setTimeout(() => {
              navigate(`/facturar/descarga/${rfc}`);
            }, 1000);
          }
        });
      }, 1000);
    } catch (error) {
      setData({ ...data, loading: false, error: true });
    }
  };


  const handleBack = () => {
    navigate("/", { replace: true });
  };
  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={1} justifyContent="center">
        <Grid item xs={12} sx={styleItem}>
          <label style={{ color: "#fff" }}>RFC</label>
          <TextField
            autoFocus={true}
            name="rfc"
            value={rfc}
            onChange={handleInputOnChange}
            variant="outlined"
            fullWidth
            error={fieldErrors.rfc ? true : false}
            helperText={fieldErrors.rfc || ""}
            InputProps={{
              style: {
                backgroundColor: "#fff",
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={9} sx={styleItem}>
          <label style={{ color: "#fff" }}>NOMBRE</label>
          <TextField
            name="name"
            value={name}
            onChange={handleInputOnChange}
            variant="outlined"
            fullWidth
            error={fieldErrors.name ? true : false}
            helperText={fieldErrors.name || ""}
            InputProps={{
              style: {
                backgroundColor: "#fff",
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={3} sx={styleItem}>
          <label style={{ color: "#fff" }}>C.P</label>
          <TextField
            type="number"
            name="postalCode"
            value={postalCode}
            onChange={handleInputOnChange}
            variant="outlined"
            fullWidth
            error={fieldErrors.postalCode ? true : false}
            helperText={fieldErrors.postalCode || ""}
            InputProps={{
              style: {
                backgroundColor: "#fff",
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sx={styleItem}>
          <CustomSelect
            label="SELECCIONAR UN REGIMEN"
            name="regime"
            value={regime}
            handleChange={(e) => handleInputOnChange(e, true)}
            options={dataResponse?.regimes}
            error={fieldErrors.regime ? true : false}
            helperText={fieldErrors.regime || ""}
            inputProps={{
              style: {
                backgroundColor: "#fff",
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={8} sx={styleItem}>
          <CustomSelect
            label="SELECCIONAR UN USO"
            name="use"
            value={use}
            handleChange={(e) => handleInputOnChange(e, true)}
            options={dataResponse?.uses}
            error={fieldErrors.use ? true : false}
            helperText={fieldErrors.use || ""}
            inputProps={{
              style: {
                backgroundColor: "#fff",
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4} sx={styleItem}>
          <CustomSelect
            label="EFECTIVO"
            name="payment"
            value={payment}
            handleChange={(e) => handleInputOnChange(e, true)}
            options={dataResponse?.paymentTypes}
            error={fieldErrors.payment ? true : false}
            helperText={fieldErrors.payment || ""}
          />
        </Grid>
        <Grid item xs={12} sx={styleItem}>
          <label style={{ color: "#fff" }}>EMAIL</label>
          <TextField
            type="email"
            name="email"
            value={email}
            onChange={handleInputOnChange}
            variant="outlined"
            fullWidth
            error={fieldErrors.email ? true : false}
            helperText={fieldErrors.email || ""}
            InputProps={{
              style: {
                backgroundColor: "#fff",
              },
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: !match2 ? "column" : "row",
            gap: 2,
          }}
        >
          <Button variant="outlined" fullWidth onClick={handleBack}>
            Atras
          </Button>
          <Button variant="unu-outlined" fullWidth onClick={cleanForm}>
            Limpiar
          </Button>
          <LoadingButton
            fullWidth
            variant="unu"
            onClick={handleSubmit}
            loading={loading}
          >
            Enviar
          </LoadingButton>
        </Grid>
      </Grid>
    </form>
  );
};
